const normalizeBase64Image = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();

  // Already a proper data URL → keep as-is
  if (/^data:image\/(png|jpeg|jpg|webp|gif);base64,/i.test(trimmed)) {
    return trimmed;
  }

  // Data URL with wrong type → coerce to image/jpeg
  if (/^data:.*;base64,/i.test(trimmed)) {
    return trimmed.replace(/^data:[^;]+;base64,/i, "data:image/jpeg;base64,");
  }

  // Raw base64 — detect PNG signature (starts with iVBORw0KGgo)
  const mime = trimmed.startsWith("iVBORw0KGgo") ? "png" : "jpeg";

  if (/^[A-Za-z0-9+/=\r\n]+$/.test(trimmed)) {
    return `data:image/${mime};base64,${trimmed.replace(/\s+/g, "")}`;
  }

  return trimmed;
};

// Function to check if selected date is today or future but not past
const isTodayOrFuture = (date) => {
  if (!date) return false;

  const toComparable = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // lexicographically sortable
  };

  const today = new Date();
  const selected = new Date(date);

  return toComparable(selected) >= toComparable(today);
};

export { normalizeBase64Image, isTodayOrFuture };
